import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setLoggedOut } from "../redux/auth/auth.actions";
import { setLoggedIn } from "../redux/auth/auth.actions";

function Navbar() {

  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  const handleLogin = () => {
    dispatch(setLoggedIn());
    // Add any other login logic, e.g., redirect to GitHub OAuth
  };

  return (
    <nav className="nav">
      <Link to="/" className="site-title">
        Github Repo Analyser
      </Link>
      <ul>
        <li>
          <Link to="/UserInfo">Repos</Link>
        </li>
        <li>
          <Link to="/about">About</Link>
        </li>
        <li>
          <button
            onClick={() =>
              isLoggedIn ? dispatch(setLoggedOut()) : handleLogin()
            }
          >
            {isLoggedIn ? "Logout" : "Login"}
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default Navbar;
